/**
 * Response-UI feature flags (UI_IMPLEMENTATION_PLAN Stages 2 and 4).
 *
 * Both default **on**, in every build. The env vars are kill switches, not
 * opt-ins: set one to `false` to fall back.
 *
 * On-by-default is deliberate and is what the plan's definition of done asks
 * for. Stage 2 fixes four defects that are live in production today — literal
 * `###`, markdown tables rendered as pipe characters, missing italic/link
 * formatting, and lists shattered by a blank line — and it carries a citation
 * parity test proving marker count and order are identical to the old path.
 * Shipping it dark would mean shipping the defects.
 *
 * Stage 4 inference (`phaseList`) measured 91% adherence over 22 relevant live
 * captures with zero false positives on short answers, which clears the plan's
 * permanent-rollout bar. It is also inert unless the agent-side contract is on:
 * adherence without it is 0%, so the rule simply never matches and every
 * segment falls through to markdown. See docs/UI_STAGE0_EVIDENCE.md.
 *
 * The one thing that stays off by default is the *agent* side —
 * `DO_CHAT_OUTPUT_FORMAT_CONTRACT` in `do_chat_agents/output_format.py`. A
 * prompt change can move answer quality, not just answer shape, so it gets a
 * per-environment rollout (preflight P5). These two flags cannot.
 */

function flag(name) {
  return import.meta.env[name] !== 'false'
}

/** Stage 2 — react-markdown + remark-gfm instead of `renderTextBlock`. */
export function isMarkdownRendererEnabled() {
  return flag('VITE_MARKDOWN_RENDERER')
}

/** Stage 4 — structural block inference over the rendered markdown. */
export function isResponseBlockInferenceEnabled() {
  return flag('VITE_RESPONSE_BLOCK_INFERENCE')
}
